// @format
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withProps, compose } from 'recompose';
import { evolve, ifElse, isEmpty, isNil, always, __, concat } from 'ramda';

import './DownloadButton.css';

const DownloadButton = ({ className, idPrefix, iconOnly }) => (
  <div className={classnames('DownloadButton', className)}>
    <a
      href="https://itunes.apple.com/tw/app/facial-labs/id1358561662"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div
        className="download-icon ios"
        id={`${idPrefix}App-download-iOS`}
        data-name="iOS"
      />
    </a>
    <a
      href="https://play.google.com/store/apps/details?id=io.facialapp.www"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div
        className="download-icon android"
        id={`${idPrefix}App-download-android`}
        data-name="Android"
      />
    </a>
  </div>
);

DownloadButton.propTypes = {
  className: PropTypes.string,
  idPrefix: PropTypes.string,
  iconOnly: PropTypes.bool,
};

export default compose(
  withProps(
    evolve({
      idPrefix: ifElse(compose(isEmpty, isNil), always(''), concat(__, '-')),
    }),
  ),
)(DownloadButton);



// WEBPACK FOOTER //
// ./src/modules/components/DownloadButton/DownloadButton.js